var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"show":_vm.show}})
}
var staticRenderFns = []

export { render, staticRenderFns }